import { __makeTemplateObject } from '../../../../../../node_modules/tslib/tslib.es6.js';
import { styled } from '@mui/material';

var Layout = styled("div")(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"])));
var Icon = styled("div")(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-right: 8px;\n  display: flex;\n  align-items: center;\n"], ["\n  margin-right: 8px;\n  display: flex;\n  align-items: center;\n"])));
var templateObject_1, templateObject_2;

export { Icon, Layout };
